import { render, staticRenderFns } from "./removeResourcePopup.vue?vue&type=template&id=7e151d70&"
import script from "./removeResourcePopup.vue?vue&type=script&lang=js&"
export * from "./removeResourcePopup.vue?vue&type=script&lang=js&"
import style0 from "./popups.less?vue&type=style&index=0&module=popup&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["popup"] = (style0.locals || style0)
        Object.defineProperty(this, "popup", {
          configurable: true,
          get: function () {
            return cssModules["popup"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./popups.less?vue&type=style&index=0&module=popup&lang=css&"], function () {
          var oldLocals = cssModules["popup"]
          if (oldLocals) {
            var newLocals = require("./popups.less?vue&type=style&index=0&module=popup&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["popup"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("7e151d70")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e151d70')) {
      api.createRecord('7e151d70', component.options)
    } else {
      api.reload('7e151d70', component.options)
    }
    module.hot.accept("./removeResourcePopup.vue?vue&type=template&id=7e151d70&", function () {
      api.rerender('7e151d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/resources/components/popups/removeResourcePopup.vue"
export default component.exports